module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-kz-c912c0af086390ae69ec293f6c4d2884.png";